import { API_ORIGIN } from '../config';
const API_BASE_URL = API_ORIGIN;

const ticketService = {
  // Create a new ticket (delete or amend request)
  createTicket: async (ticketData) => {
    try {
      const response = await fetch(`${API_BASE_URL}/api/direct-order/tickets`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'include',
        body: JSON.stringify(ticketData)
      });

      const data = await response.json();

      if (!response.ok) {
        return {
          success: false,
          error: data.error || data.message || 'Failed to create ticket',
          status: response.status,
          existingTicketId: data.existing_ticket_id
        };
      }

      return {
        success: true,
        message: data.message,
        ticketId: data.ticket_id
      };
    } catch (error) {
      return {
        success: false,
        error: error.message || 'Network error occurred'
      };
    }
  },

  // Get all tickets (admin view)
  listTickets: async (filters = {}) => {
    try {
      const queryParams = new URLSearchParams();
      if (filters.status) queryParams.append('status', filters.status);
      if (filters.doId) queryParams.append('doId', filters.doId);
      if (filters.type) queryParams.append('type', filters.type);
      if (filters.email) queryParams.append('email', filters.email);

      const url = `${API_BASE_URL}/api/direct-order/tickets${queryParams.toString() ? '?' + queryParams.toString() : ''}`;

      const response = await fetch(url, {
        method: 'GET',
        credentials: 'include',
      });

      const data = await response.json();

      if (!response.ok) {
        return {
          success: false,
          error: data.error || 'Failed to fetch tickets'
        };
      }

      return {
        success: true,
        tickets: data.tickets || []
      };
    } catch (error) {
      return {
        success: false,
        error: error.message || 'Network error occurred'
      };
    }
  },

  // Get tickets for a specific Direct Order
  getTicketsByDO: async (doId) => {
    try {
      const response = await fetch(`${API_BASE_URL}/api/direct-order/tickets/by-do/${doId}`, {
        method: 'GET',
        credentials: 'include',
      });

      const data = await response.json();

      if (!response.ok) {
        return {
          success: false,
          error: data.error || 'Failed to fetch tickets for this Direct Order'
        };
      }

      return {
        success: true,
        tickets: data.tickets || []
      };
    } catch (error) {
      return {
        success: false,
        error: error.message || 'Network error occurred'
      };
    }
  },

  // Get single ticket by ID
  getTicket: async (ticketId) => {
    try {
      const response = await fetch(`${API_BASE_URL}/api/direct-order/tickets/${ticketId}`, {
        method: 'GET',
        credentials: 'include',
      });

      const data = await response.json();

      if (!response.ok) {
        return {
          success: false,
          error: data.error || 'Failed to fetch ticket'
        };
      }

      return {
        success: true,
        ticket: data.ticket
      };
    } catch (error) {
      return {
        success: false,
        error: error.message || 'Network error occurred'
      };
    }
  },

  // Edit an open amend ticket
  editTicket: async (ticketId, updates) => {
    try {
      const response = await fetch(`${API_BASE_URL}/api/direct-order/tickets/${ticketId}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'include',
        body: JSON.stringify(updates)
      });

      const data = await response.json();

      if (!response.ok) {
        return {
          success: false,
          error: data.error || 'Failed to update ticket'
        };
      }

      return {
        success: true,
        message: data.message
      };
    } catch (error) {
      return {
        success: false,
        error: error.message || 'Network error occurred'
      };
    }
  },

  // Approve a ticket
  approveTicket: async (ticketId, userEmail, adminComment = '') => {
    try {
      const response = await fetch(`${API_BASE_URL}/api/direct-order/tickets/${ticketId}/approve`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'include',
        body: JSON.stringify({
          userEmail,
          admin_comment: adminComment
        })
      });

      const data = await response.json();

      if (!response.ok) {
        return {
          success: false,
          error: data.error || 'Failed to approve ticket'
        };
      }

      return {
        success: true,
        message: data.message,
        fullyApproved: data.fully_approved
      };
    } catch (error) {
      return {
        success: false,
        error: error.message || 'Network error occurred'
      };
    }
  },

  // Reject a ticket
  rejectTicket: async (ticketId, userEmail, adminComment = '') => {
    try {
      const response = await fetch(`${API_BASE_URL}/api/direct-order/tickets/${ticketId}/reject`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'include',
        body: JSON.stringify({
          userEmail,
          admin_comment: adminComment
        })
      });

      const data = await response.json();

      if (!response.ok) {
        return {
          success: false,
          error: data.error || 'Failed to reject ticket'
        };
      }

      return {
        success: true,
        message: data.message
      };
    } catch (error) {
      return {
        success: false,
        error: error.message || 'Network error occurred'
      };
    }
  }
};

export default ticketService;
